<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main boxshadow">
            <div class="basics-section boxshadow">
                <div class="basics-section-main">
                    <div class="head">
                        <span class="head-1">店铺产品</span>
                        <span class="head-2">Basic Optimization</span>
                    </div>
                    <div class="cont" style="padding: 0 10px">
                        <el-table
                                header-row-class-name="custom-header-style"
                                cell-class-name="custom-style"
                                :data="productList"
                                style="width: 100%">
                            <el-table-column
                                    align="center"
                                    prop="image"
                                    label="图片"
                                    width="60px">
                                <template slot-scope="scope">
                                    <img :src="scope.row.image" alt="" height="52px" style="max-width: 52px">
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="sku"
                                    align="center"
                                    label="SKU">
                            </el-table-column>
                            <el-table-column
                                    prop="title"
                                    class-name="title"
                                    label="标题">
                            </el-table-column>
                            <el-table-column
                                    align="center" prop="brand"
                                    label="品牌">
                            </el-table-column>
                            <el-table-column
                                    align="center" prop="inventory"
                                    label="库存">
                            </el-table-column>
                            <el-table-column
                                    align="center" prop="inventory"
                                    min-width="110px"
                                    label="销售状态">
                                <template slot-scope="scope">
                                    <div>
                                        <span v-if="scope.row.status === 1"
                                              style="background: #FF9800;font-size: 12px;color: #FFFFFF;padding: 6px 12px;border-radius: 23px;display: inline-block;width: 80px">
                                            正常售卖
                                        </span>
                                        <span v-if="scope.row.status === 2 && (Date.now() < scope.row.startTime)"
                                              style="background: #2196F3;font-size: 12px;color: #FFFFFF;padding: 6px 12px;border-radius: 23px;display: inline-block;width: 80px">
                                            活动 - 未开始
                                        </span>
                                        <span v-if="scope.row.status === 2 && (Date.now() > scope.row.startTime) && (Date.now() < scope.row.endTime)"
                                              style="background: #ff1100;font-size: 12px;color: #FFFFFF;padding: 6px 12px;border-radius: 23px;display: inline-block;width: 80px">
                                            活动 - 进行中
                                        </span>
                                        <span v-if="scope.row.status === 2 && (Date.now() > scope.row.endTime)"
                                              style="background: #9E9E9E;font-size: 12px;color: #FFFFFF;padding: 6px 12px;border-radius: 23px;display: inline-block;width: 80px">
                                            活动 - 已失效
                                        </span>
                                        <span v-if="scope.row.status === 0"
                                                  style="background: #9E9E9E;font-size: 12px;color: #FFFFFF;padding: 6px 12px;border-radius: 23px;display: inline-block;width: 80px">
                                            已下架
                                        </span>
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="address"
                                    label="价格USD">
                                <template slot-scope="scope">
                                    <div style="display: flex;flex-direction: column">
                                        <span>{{scope.row.price}}</span>
                                        <span style="text-decoration: line-through;color: #9E9E9E;">{{scope.row.msrp}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="address"
                                    label="活动价格USD">
                                <template slot-scope="scope">
                                    <span>{{scope.row.status ===2?scope.row.promotionPrice : '-'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    min-width="180px"
                                    align="center"
                                    label="活动时间">
                                <template slot-scope="scope">
                                    <div style="display: flex;flex-direction: column" v-if="scope.row.status ===2">
                                        <span style="font-size: 14px;font-weight: bolder;color: #089bab;">{{new Date(scope.row.startTime).$Format('yyyy-MM-dd hh:mm:ss')}}</span>
                                        <span style="font-size: 14px;font-weight: bolder;color: #089bab;">{{new Date(scope.row.endTime).$Format('yyyy-MM-dd hh:mm:ss')}}</span>
                                    </div>
                                    <div v-else>
                                        <span>-</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="220" >
                                <template slot-scope="scope">
                                    <div class="table-row-handle">
                                        <span @click="optimizeProductFn(scope.row)">优化</span>
                                        <span :class="scope.row.status===2?'cancel':'set'" @click="handleCommand({data:scope.row,index:1})" v-if="scope.row.status !== 0">{{scope.row.status===2?'取消活动':'设置活动'}}</span>
                                        <span @click="handleCommand({data:scope.row,index:2})" v-if="scope.row.status !== 2">{{scope.row.status === 0 ? '上架' : '下架' }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-wrap">
            <div class="pagination">
                <el-pagination
                        prev-text="上一页"
                        next-text="下一页"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="productListPagination.pageNo"
                        :page-size="productListPagination.pageSize"
                        layout="prev, pager, next, jumper, slot, total"
                        :total="productListPagination.total">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </el-pagination>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
        <el-dialog :visible.sync="showSetPromotion" custom-class="set-promotion-dialog radius el-dialog-custom"
                   width="1060px">
            <div slot="title">
                <div class="basics-section " style="padding: 0">
                    <div class="basics-section-main">
                        <div class="head label">
                            <span class="head-1">活动设置</span>
                            <span class="head-2">Event settings</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main">
                <div class="main-item">
                    <div>Price($)</div>
                    <div>{{promotionData.price}}</div>
                </div>
                <div class="main-item">
                    <div>MSRP($)</div>
                    <div>{{promotionData.msrp}}</div>
                </div>
                <div class="main-item">
                    <div>Sale Price($)</div>
                    <div style="padding: 0">
                        <input type="text" v-model.number="promotionData.promotionPrice">
                    </div>
                </div>
                <div class="main-item">
                    <div>Start Time - End Time</div>
                    <div style="padding: 4px">
                        <el-date-picker
                                v-model="promotionData.date"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="footer">
                <span class="btn boxshadow" @click="showSetPromotion=false">
                    取消
                </span>
                <span class="btn active boxshadow" @click="setPromotion">
                    确认
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="canclePromotion" custom-class="set-promotion-dialog radius el-dialog-custom"
                   width="1060px">
            <div slot="title">
                <div class="basics-section " style="padding: 0">
                    <div class="basics-section-main">
                        <div class="head label">
                            <span class="head-1">取消活动</span>
                            <span class="head-2">Event settings</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main">
                <div class="cancle-wrap">
                    <div class="cancle-wrap-item" :class="{active:canclePromotionData.status===1}"
                         @click="canclePromotionData.status = 1">
                        <div class="item-box">
                            <span>取消活动</span>
                            <i class="iconfont icontransfer-two"></i>
                            <span>正常售卖</span>
                        </div>
                    </div>
                    <div class="cancle-wrap-item" :class="{active:canclePromotionData.status===0}"
                         @click="canclePromotionData.status = 0">
                        <div class="item-box">
                            <span>取消活动</span>
                            <i class="iconfont icontransfer-two"></i>
                            <span>下架</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <span class="btn boxshadow" @click="canclePromotion=false">
                    取消
                </span>
                <span class="btn active boxshadow" @click="cancel">
                    确认
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="optimizeProduct" custom-class="set-promotion-dialog radius el-dialog-custom"
                   width="96%" top="10px">
            <div slot="title">
                <div class="basics-section " style="padding: 0">
                    <div class="basics-section-main">
                        <div class="head label">
                            <span class="head-1">优化产品</span>
                            <span class="head-2">Optimize Product</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding: 0 20px">
                <edit-product v-if="optimizeProduct" :optimizeProductData="optimizeProductData" @closeDig="closeDig"
                              :submitData="{url:'editor'}"></edit-product>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import EditProduct from "../components/EditProduct"

    export default {
        name: "choose",
        components: {
            EditProduct
        },
        data() {
            return {
                promotionData: {
                    id: '',
                    startTime: '',
                    endTime: '',
                    promotionPrice: '',
                    date: [],
                    price: '',
                    msrp: ''
                },
                currentPage3: 0,
                showSetPromotion: false,
                canclePromotion: false,
                optimizeProduct: false,
                optimizeProductData: {},
                canclePromotionData: {
                    id: '',
                    status: 1
                },
                productList:[],
                productListPagination:{
                    pageNo:1,
                    pageSize:20
                }
            }
        },
        created() {
            this.getProduct();
        },
        methods: {
            closeDig(type) {
                this.optimizeProduct = false;
                if (type) this.getProduct();
            },
            optimizeProductFn(row) {
                this.optimizeProduct = true;
                this.optimizeProductData = row;
            },
            cancel() {
                this.axios.post('/student/product/cancel', this.canclePromotionData).then(res => {
                    if (res.succeed) {
                        this.$message.success(res.message);
                        this.canclePromotion = false;
                        this.getProduct()
                    }
                })
            },
            setPromotion() {
                if(!this.promotionData.promotionPrice){
                    this.$message.error('活动价格不能为空')
                    return  false
                }
                if(!this.promotionData.date || this.promotionData.date.length <1){
                    this.$message.error('活动时间不能为空');
                    return false
                }
                this.promotionData.startTime = new Date(this.promotionData.date[0]).$Format('yyyy-MM-dd hh:mm:ss');
                this.promotionData.endTime = new Date(this.promotionData.date[1]).$Format('yyyy-MM-dd hh:mm:ss');
                this.axios.post('/student/product/promotion', this.promotionData).then(res => {
                    if (res.succeed) {
                        this.$message.success(res.message);
                        this.showSetPromotion = false;
                        this.getProduct()
                    }
                })
            },
            handleCommand(obj) {
                switch (obj.index) {
                    case 1:
                        if (obj.data.status === 1) {
                            //正常售卖===>设置活动
                            for (let i in this.promotionData) {
                                this.promotionData[i] = obj.data[i]
                            }
                            this.showSetPromotion = true;
                        } else if (obj.data.status === 2) {
                            //活动中===>取消活动
                            this.canclePromotionData.id = obj.data.id;
                            this.canclePromotion = true;
                        }
                        break;
                    case 2:
                        //0：下架，1：售卖，2：活动
                        let $property = {
                            confirmTxt: obj.data.status === 0 ? '上架' : '下架',
                            confirmButtonText: obj.data.status === 0 ? '上架' : '下架',
                            url: '/student/product/status',
                            status: obj.data.status === 0 ? 1 : 0
                        }
                        this.$confirm(`确认${$property.confirmTxt}?`, '提示', {
                            confirmButtonText: $property.confirmButtonText,
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.axios.post($property.url, {id: obj.data.id, status: $property.status}).then(res => {
                                if (res.succeed) {
                                    this.$message({
                                        type: 'success',
                                        message: res.message
                                    });
                                    this.getProduct()
                                }
                            })
                        }).catch(() => {

                        });
                        break;
                }
            },
            getProduct() {
                let params = {
                    pagination:{
                        pageNo:this.productListPagination.pageNo,
                        pageSize:this.productListPagination.pageSize,
                    }
                }
                this.axios.post('/student/product/list',params).then(res=>{
                    if(res.succeed && res.login){
                        this.productList = res.items
                        this.productListPagination = res.pagination
                    }
                })
            },
            handleSizeChange() {

            },
            handleCurrentChange(val) {
                this.productListPagination.pageNo = val;
                this.getProduct()
            }
        }
    }
</script>

<style scoped lang="scss">

    .table-row-handle {
        display: flex;
        span {
            padding: 6px 12px;
            background: #F44336;
            margin-right: 6px;
            margin-bottom: 6px;
            border-radius: 8px;
            color: #ffffff;
            cursor: pointer;
            word-break: keep-all;
            &.cancel {
                background: #FDAD53;
            }
            &.set {
                background: #4149A9;
            }
        }
    }

    .main {
        div.table-wrap {
            padding: 30px;

        }
    }

    .pagination-wrap {
        margin-top: 30px;
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }

    .set-promotion-dialog {
        .main {
            display: flex;
            justify-content: center;
            padding-bottom: 50px;

            > div.main-item {
                display: flex;
                flex-direction: column;
                font-size: 16px;
                font-weight: bolder;
                align-items: center;
                margin-right: 32px;

                > div {
                    &:first-child {
                        margin-bottom: 10px;
                    }

                    &:last-child {
                        padding: 15px 58px;
                        background: #089bab;
                        color: #FFFFFF;
                        border-radius: 10px;

                        input {
                            width: 130px;
                            border: 1px dashed #ff9800;
                            height: 48px;
                            line-height: 48px;
                            border-radius: 10px;
                            outline: none;
                            padding: 0 10px;
                            box-sizing: border-box;
                            font-weight: bolder;
                            text-align: center;
                        }
                    }
                }
            }

            div.cancle-wrap {
                display: flex;
                align-items: center;

                div.cancle-wrap-item {
                    border: 1px dashed #adadad;
                    padding: 36px;
                    border-radius: 10px;
                    /*transition: all 0.3s linear;*/
                    cursor: pointer;

                    &:first-child {
                        margin-right: 30px;
                    }

                    &:hover, &.active {
                        background: rgba(255, 152, 0, 0.21);
                        /*transition: all 0.3s linear;*/
                    }

                    .item-box {
                        border-radius: 20px;
                        background: #FDAD53;
                        color: #FFFFFF;
                        padding: 10px 20px;

                        i {
                            padding: 0 30px;
                        }
                    }
                }
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 30px;
        }
    }
</style>
